<ng-content select="page"></ng-content>
